import { useFindTagAtCaret } from "@web/components/tag/use-find-tag-at-caret";
import { useCallback } from "react";
import { TAG_DELIMITER, useTagBox } from "./TagBox";

export const useTagSelect = () => {
  const { value, suggestions, setSuggestions, onChange, inputRef, mode, onTagSelect, idx } = useTagBox();
  const findTagAtCaret = useFindTagAtCaret();

  const selectTag = useCallback(
    (index?: number) => {
      if (!inputRef?.current) return;

      const currentIndex = index !== undefined ? index : idx;

      // In combo box mode, we fire the onTagSelect callback reset to the default set of suggestions
      if (mode === "combo") {
        onTagSelect?.(suggestions[currentIndex]);
        onChange("");
        return true;
      }

      const input = inputRef.current;
      const position = input.selectionStart ?? 0;
      const tagInfo = findTagAtCaret();
      if (!tagInfo) return false;

      // Build the new value of the input field after selecting a tag
      const beforeTag = value.slice(0, tagInfo.start);
      const afterTag = value.slice(position);
      const selectedTag = suggestions[currentIndex];
      const newValue = `${beforeTag}${TAG_DELIMITER}${selectedTag} ${afterTag}`;
      onChange(newValue);

      // Update caret position to the end of the selected tag
      const newPosition = tagInfo.start + selectedTag.length + TAG_DELIMITER.length + 1;
      setSuggestions([]);
      setTimeout(() => {
        input.setSelectionRange(newPosition, newPosition);
      }, 0);
      return true;
    },
    [findTagAtCaret, idx, inputRef, mode, onChange, onTagSelect, setSuggestions, suggestions, value]
  );

  return selectTag;
};
